import { useUserInformationContext } from 'contexts/userContext';
import React from 'react';

import OnboardingWelcomeScene from './onboarding-welcome-scene';
import useOnboardingWelcome from './use-onboarding-welcome';

const OnboardingWelcome = () => {
  const {
    t,
    theme,
    updatePartyMutation,
  } = useOnboardingWelcome();
  const { currentUser } = useUserInformationContext();

  const handle = () => {
    if (currentUser) {
      updatePartyMutation({
        id: currentUser._id,
        data: {
          onboarded: true
        }
      });
    }
  };

  return (
    <OnboardingWelcomeScene
      t={t}
      theme={theme}
      handle={handle}
    />
  );
};

export default OnboardingWelcome;
